export const GMAT_SET_CATALOG = "GMAT_SET_CATALOG";
export const GMAT_SET_LOAD_ERROR = "GMAT_SET_LOAD_ERROR";
export const GMAT_MARK_LESSON_COMPLETE = "GMAT_MARK_LESSON_COMPLETE";
